module.exports = __webpack_public_path__ + "static/media/carousel-prev.9e4454de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/carousel-prev.svg
// module id = 2389
// module chunks = 0